/**
 * Matomo-kategori (Adfærd → Hændelser).
 * notifikationsserver/matomo-events.ts dublerer server-værdierne; push-matomo-events.spec.ts holder dem i sync.
 */
export const PUSH_MATOMO_CATEGORY = "Notifikationer";

/**
 * Event Action i Matomo. Alle handler om push-notifikationer.
 * `notification_offer_*` = tilbud om at slå notifikationer til i appen (ikke selve udsendelsen).
 */
export const PushMatomoAction = {
    eligibilityEvaluated: "notification_eligibility_evaluated",
    offerSkipped: "notification_offer_skipped",
    offerShown: "notification_offer_shown",
    offerAccepted: "notification_offer_accepted",
    offerBlocked: "notification_offer_blocked",
    reminderShown: "notification_reminder_shown",
    reminderAccepted: "notification_reminder_accepted",
    reminderSnoozed: "notification_reminder_snoozed",
    osPermissionGranted: "notification_os_permission_granted",
    osPermissionDenied: "notification_os_permission_denied",
    subscribeSuccess: "notification_subscribe_success",
    subscribeFailed: "notification_subscribe_failed",
    unsubscribeSuccess: "notification_unsubscribe_success",
    unsubscribeFailed: "notification_unsubscribe_failed",
    notificationOpened: "notification_opened",
    notificationSent: "notification_sent",
    notificationDead: "notification_dead_token"
} as const;

export type PushSkipReason =
    | "not_logged_in"
    | "not_capacitor"
    | "fof_user"
    | "no_installation"
    | "status_error"
    | "already_subscribed"
    | "cooldown"
    | "status_pending"
    | "os_denied";

export function pushSkipLabel(reason: PushSkipReason): string {
    return reason;
}

export const PUSH_MATOMO_NAME = {
    overwriteCancelled: "overwrite_cancelled",
    missingAppServer: "missing_app_server",
    missingUserId: "missing_user_id",
    missingForsyningId: "missing_forsyning_id"
} as const;
